import { Reveal, Kicker } from "./Reveal";

const STACK = [
  ["AXIOSERA", "Commercial Decision Infrastructure", true],
  ["PRICESTRIKE", "Governed autonomous pricing", false],
  ["PRICING", "First live decision family", false],
  ["EXPANSION", "Promotions · Markdown · Inventory allocation · Rebates · Discount authority", false],
];

const PRIMITIVES = ["Decision", "Policy", "Autonomy", "Execution", "Ledger", "Outcome"];

export default function Platform() {
  return (
    <section id="platform" className="border-b border-white/10" data-testid="platform-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <Kicker index="08" label="Product and platform" />
          <h2 className="max-w-5xl font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl" data-testid="platform-heading">
            PriceStrike proves the wedge. <span className="text-[#00FF41]">Axiosera owns the control layer.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid gap-16 lg:grid-cols-12">
          <Reveal className="lg:col-span-6">
            <div className="space-y-0" data-testid="platform-stack">
              {STACK.map(([name, sub, top], i) => (
                <div key={name}>
                  <div className={`border p-8 transition-colors duration-500 ${top ? "border-[#00FF41]/50 bg-[#0F0F11]" : "border-white/10 hover:bg-[#0F0F11]"}`}>
                    <div className={`font-display text-2xl font-extrabold tracking-tighter ${top ? "text-[#00FF41]" : "text-white"}`}>{name}</div>
                    <div className="mt-2 font-mono text-xs text-zinc-500">{sub}</div>
                  </div>
                  {i < STACK.length - 1 && <div className="py-2 text-center font-mono text-[#00FF41]">↓</div>}
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-6">
            <p className="font-mono text-sm leading-relaxed text-zinc-400">
              PriceStrike uses the same core infrastructure intended to support additional commercial
              decision families:
            </p>
            <div className="mt-8 grid grid-cols-2 gap-px border border-white/10 bg-white/10 sm:grid-cols-3" data-testid="platform-primitives">
              {PRIMITIVES.map((p) => (
                <div key={p} className="bg-[#050505] px-6 py-5 text-center font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 transition-colors duration-300 hover:text-[#00FF41]">
                  {p}
                </div>
              ))}
            </div>
            <p className="mt-8 border-l-2 border-[#00FF41] pl-6 font-mono text-sm leading-relaxed text-zinc-300" data-testid="platform-proof">
              The long-term platform proof is that a second commercial decision family can be added
              without rebuilding those governance primitives.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
